<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <div class="main_content">
            <section class="bread_crumb">
                <div class="container">
                    <ul>
                        <li>
                            <router-link class="" v-bind:to="'/'">Home</router-link>
                        </li>
                        <li>معلومات عنا</li>
                    </ul>
                </div>
            </section>
            <div class="about-us arabic_banner_sec custom-banner-section">
                <div class="row m-0">
                    <div class="col-md-6 p-0">

                    </div>
                    <div class="col-md-6 p-0">
                        <div class="about_main_image">
                            <img src="../../assets/images/ar-about-banner.jpg" alt="about_arabic" />

                            <div class="about_main_title">
                                <h4>معلومات عنا</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="about_content_wrapper arabic_content_wrap">
                <div class="container">
                    <div class="about_content_block">
                        <h5>من نحن؟</h5>
                        <p>
                        تأسست نما الطبية عام ٢٠١٤ م، ويقع مقرها الرئيسي في مدينة الرياض عاصمة المملكة العربية السعودية. تعمل نما الطبية من خلال ثلاث فروع:
الحلول الصحية الرقمية، الخدمات الاستشارية، مركز نما للتدريب الصحي.
وجميع هذه الفروع تخدم المنشآت الصحية من خلال رفع مستويات الأداء والمخرجات الصحية.</p>

<p>تقدم نما الطبية أفضل الحلول التقنية وبرامج التحول وتتميز منتجاتنا بأنها محققة لجميع الاشتراطات المعدة من قبل الجهات الرقابية المعنية.
وهذا ممكن من خلال فريق عمل من الاستشاريين والأخصائيين العاملين في نما بالشراكة مع شركاء نما في الولايات المتحدة الأمريكية وبريطانيا والهند.</p>

<p>مركز نما للتدريب الصحي معتمد من قبل الهيئة السعودية للتخصصات الصحية من أجل تقديم خدمات التدريب المهني والتطوير المستمر للممارسين الصحيين داخل المملكة العربية السعودية.
ويعمل المركز في مجالات عدة على سبيل المثال لا الحصر: جودة العناية الصحية، سلامة المرضى، التعليم الطبي المهني، البحث الطبي.
اليوم للمركز اتفاقات عدة مع جهات حكومية داخل المملكة العربية السعودية ومعاهد أكاديمية دولية غير ربحية.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import AboutSideBar from './AboutSideBar'
import router from '../../router'
import EventBus from '../EventBus'

export default{
    data(){
    	this.get_page_content();
        return {
            page_title:null,
            page_content:null
        }
    },
    components:{
        HeaderMenu:HeaderMenu,
        AboutSideBar:AboutSideBar
    },
    methods:{
        async get_page_content() {
        	/*var _self = this;
            var current_slug = _self.$route.params.slug;
            await axios.post(_self.$hostname+'/api/static-pages',
            {
              slug:current_slug,lang:_self.$i18n_global.locale
            })
            .then((res) => {
                var response = res.data.data;
                _self.page_title = _self.$i18n_global.locale=="en" ? response.heading_eng : response.heading_ar;
                _self.page_content = _self.$i18n_global.locale=="en" ? response.description_eng : response.description_ar;
            })
            .catch((error) => {

                return false;
            })
            return false; */
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/AboutUsArabic.vue